module.exports = __webpack_public_path__ + "img/logo_black.0c36325e.svg";